import React from 'react';

interface InsulinSyringeChartProps {
    syringeCapacity?: number;
    syringeUnits?: number;
}

export const SyringeHorizontalViewOnly: React.FC<InsulinSyringeChartProps> = ({
    syringeCapacity = 100, // Default to 100 ml
    syringeUnits = 0,
}) => {
  const maxUnits = syringeCapacity; // Use syringe size to determine max units

  const syringeWidth = 300;
  const syringeHeight = 60;
  const markingGap = (syringeWidth - 40) / maxUnits;

  const plungerHeight = 70;
  const plungerWidth = 10;
  const needleBaseHeight = 20;

  return (
    <svg
      width={syringeWidth + 10}
      height={syringeHeight + 80}
      className="cursor-pointer"
      style={{ userSelect: 'none' }}
    >
      {/* Syringe Needle Base */}
      <rect
        x={15}
        y={syringeHeight - needleBaseHeight / 2}
        width={3}
        height={needleBaseHeight}
        fill="#334155"
        stroke="#334155"
        strokeWidth="2"
      />

      {/* Syringe Plunger */}
      <rect
        x={280}
        y={syringeHeight - plungerHeight / 2}
        width={plungerWidth}
        height={plungerHeight}
        fill="grey"
        stroke="#334155"
        strokeWidth="2"
      />
      <rect
        x={290}
        y={syringeHeight - plungerHeight / 6}
        width={plungerWidth}
        height={plungerHeight / 3}
        fill="grey"
        stroke="#334155"
        strokeWidth="2"
      />

      {/* Syringe Body */}
      <rect
        x={20}
        y={30}
        width={syringeWidth - 40}
        height={syringeHeight}
        fill="white"
        stroke="#334155"
        strokeWidth="2"
      />

      {/* Unit Markings */}
      {Array.from({ length: maxUnits + 1 }).map((_, i) => (
        <g key={i}>
          <line
            x1={20 + i * markingGap}
            y1={30 + syringeHeight}
            x2={20 + i * markingGap}
            y2={i % 10 === 0 ? 30 + syringeHeight + 15 : 30 + syringeHeight + 10}
            stroke="#334155"
            strokeWidth={i % 10 === 0 ? 2 : 1}
          />
          {i % 10 === 0 && (
            <text
              x={20 + i * markingGap}
              y={30 + syringeHeight + 30}
              textAnchor="middle"
              className="text-xs fill-slate-700"
            >
              {i}
            </text>
          )}
        </g>
      ))}

      {/* Filled Amount */}
      <rect
        x={20}
        y={31}
        width={syringeUnits * markingGap}
        height={syringeHeight - 2}
        fill="#3b82f6"
        fillOpacity="0.3"
      />

      {/* Plunger */}
      <rect
        x={20 + syringeUnits * markingGap - 2}
        y={25}
        width={8}
        height={syringeHeight + 10}
        fill="#334155"
      />
      <circle
        cx={20 + syringeUnits * markingGap + 2}
        cy={20}
        r={10}
        fill="#334155"
      />

      {/* Needle */}
      <line
        x1={0}
        y1={30 + syringeHeight / 2}
        x2={20}
        y2={30 + syringeHeight / 2}
        stroke="#334155"
        strokeWidth="2"
      />
    </svg>
  );
};
